import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// -- tech:
// tailwind css
// react-icons
// react-chartjs-2

/** -- api
 * coingecko
 * coinmarketcap
 * currencylayer
*/